export const endpoints: Record<string, string> = {
  CUMULATIVE: 'performance/cumulative',
  CUMULATIVE_DAILY: 'performance/cumulativeDaily',
  CUMULATIVE_CHART: 'performance/cumulativeChart',
  ANNUALIZED: 'performance/annualized',
  ANNUALIZED_DAILY: 'performance/annualizedDaily',
  DISCRETE: 'performance/discrete',
  DISCLAIMER: 'text/performancesDisclaimer',
  CALENDAR: 'performance/calendar',
};
